import { FC } from 'react';
import style from './AttachedFileList.module.scss';
import classNames from 'classnames/bind';
import { IFile } from '../../interface/common/common';
import Icon from '../../common/icon/Icon';
import { COLORS } from '../../constants/colors';
import { ViewModeType } from '../../interface/common/ViewMode';
import { getImageURL } from 'ats-editor/src/utils/common/file.utils';
import { fileDownload } from '../../util/file.utils';

const cx = classNames.bind(style);

interface IProps {
  fileList: IFile[];
  viewMode: ViewModeType;
  readonly?: boolean;
  className?: string;
}

const AttachedFileList: FC<IProps> = ({ fileList, viewMode, readonly = false, className }) => {
  return (
    <>
      {fileList.length > 0 && (
        <div className={cx('attached-file-container', viewMode, className)}>
          <div className={cx('title-wrapper')}>
            <Icon name={'folder_line'} size={24} color={COLORS.gray600} />
            <h3>첨부파일</h3>
          </div>
          <div className={cx('file-wrapper')}>
            {fileList.map((file) => {
              const { fileName, fileUrl } = file;
              return (
                <a
                  key={fileUrl}
                  className={cx('file-link')}
                  href={getImageURL(file) ?? ''}
                  download={fileName}
                  onClick={(e) => {
                    e.preventDefault();

                    fileDownload({ isFullPath: !!fileUrl, path: fileUrl ?? '', fileName: fileName ?? '' });
                  }}
                >
                  <div className={cx('file-icon')}>
                    <Icon name={'file_line'} size={18} color={COLORS.white} />
                  </div>
                  <p className={cx('file-name')}>{fileName}</p>
                </a>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default AttachedFileList;
